import React, {Component} from 'react';
import {connect} from "react-redux";
import * as actions from "../../actions";
import _ from 'lodash'
import {sendRequestForPrivateSession} from "../../util/firebase/firestore";
import {vuepayAlert} from "../../util/utility";
import moment from "moment";
import loading_blue from '../../assets/gif/loading_blue.gif';
import loading_white from '../../assets/gif/loading_white.gif';
import {acceptUserRequestAndCreateNewBroadcast} from "../../util/broadcast/one_to_one_request";
import {canBroadcasterAcceptOrSendInvite, getUserProfile} from "../../util/business_logic";

class InviteForSessionModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            viewer: null
        }

        //all the functions used in this component should be listed here for better documentation
        this.inviteUser = this.inviteUser.bind(this);
        this.toggleFavourite = this.toggleFavourite.bind(this);
        this.toggleBlock = this.toggleBlock.bind(this);
    }

    inviteUser = () => {
    }

    toggleFavourite = () => {
    }

    toggleBlock = () => {
    }

    componentDidMount() {

        const username = this.props.userDetails.userData.username;

        const index = _.findIndex(this.props.oneToOneRequestArray, function (o) {
            return o.username === username;
        });

        if (index !== -1) {
            this.setState({
                viewer: this.props.oneToOneRequestArray[index]
            })
        } else {
            this.setState({
                viewer: null
            })
        }

    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.hasOwnProperty("broadcaster_block_unblock_viewer") &&
            nextProps.broadcaster_block_unblock_viewer.hasOwnProperty("payload") &&
            nextProps.broadcaster_block_unblock_viewer.payload != null) {

            if (nextProps.broadcaster_block_unblock_viewer.payload.hasOwnProperty("success")) {
                vuepayAlert("success", nextProps.broadcaster_block_unblock_viewer.payload.success.message);
                this.props.toggleInviteForSessionModal()
            }
            else if (nextProps.broadcaster_block_unblock_viewer.isError) {
                vuepayAlert("error", nextProps.broadcaster_block_unblock_viewer.payload.message);
            }
            this.props.resetBlockUnBlockData()
        }
    }

    sendPrivateRequestToBroadcaster = () => {

        let data = {};
        if (this.props.availabilityID === -1) {
            data = {
                "from": "broadcaster",
                "created_at": Date.now(),
                "updated_at": Date.now(),
                "read": false,
                "status": 0,
                "username": this.props.userDetails.userData.username,
                "profile_pic": getUserProfile(this.props.userDetails.userData.profile_pic)
            };
        } else {
            data = {
                "created_at": moment.utc().toDate(),
                "created_at_human_readable": moment.utc().fromNow(),
                "from": "broadcaster",
                "id": -1,
                "is_favourite": false,
                "profile_pic": getUserProfile(this.props.userDetails.userData.profile_pic),
                "read": false,
                "status": 0,
                "updated_at": moment.utc().toDate(),
                "updated_at_human_readable": moment.utc().fromNow(),
                "user_id": this.props.userDetails.userData.user_api_id,
                "username": this.props.userDetails.userData.username,
            };
        }

        if (canBroadcasterAcceptOrSendInvite(this.props.oneToOneRequestArray)) {

            this.setState({
                isFetching: true
            }, () => {
                sendRequestForPrivateSession(`${this.props.broadcastId}`, this.props.userDetails.userData.user_api_id, data, (payload) => {
                    //Update parent component about private request status
                    this.setState({
                        isFetching: false
                    })

                    this.props.toggleInviteForSessionModal();

                    if (payload.success) {
                        vuepayAlert("success", payload.message)
                    } else {
                        vuepayAlert("error", payload.message)
                    }
                    // this.props.togglePrivateRequestStatus()
                    // this.props.togglePrivateSessionInviteModal()
                })
            })

        } else {
            //hide this pop up
            this.props.toggleInviteForSessionModal();

            //open the error modal
            this.props.toggleCommonModal();
        }
    }

    acceptRequestAndCreateNewBroadcast = (viewer_id) => {

        if (canBroadcasterAcceptOrSendInvite(this.props.oneToOneRequestArray)) {

            acceptUserRequestAndCreateNewBroadcast(this.props, viewer_id, (formData) => {
                this.setState({
                    formData: formData,
                    viewer_id: viewer_id,
                    isFetching: true
                }, () => {
                    this.props.setInteractedViewerID(viewer_id)
                });
            })

        } else {
            //hide this pop up
            this.props.toggleInviteForSessionModal();

            //open the error modal
            this.props.toggleCommonModal();
        }
    }

    render() {

        return (
            <div id="invite-for-session" className="modal fade" role="dialog" aria-labelledby="myModalLabel"
                 aria-hidden="true">
                <div className="vertical-alignment-helper">
                    <div className="modal-dialog vertical-align-center">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                        onClick={this.props.toggleInviteForSessionModal}>
                                    <img alt={"close-icon"} src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"}/></button>
                            </div>
                            <div className="modal-body">
                                <img alt="profile pic"
                                     style={{borderRadius: 100, marginBottom: 10}}
                                     src={getUserProfile(this.props.userDetails.userData.profile_pic)} width={131}/>
                                <p><strong>{this.props.userDetails.userData.username}</strong></p>
                            </div>
                            <div className="modal-footer">

                                {
                                    (this.props.private_broadcast_id !== -1) || !this.props.broadcast.one_to_one_session_allow ? ""
                                        :
                                        // check if viewer has already send a request to broadcaster then change the text
                                        this.state.viewer === null
                                            ?
                                            (
                                                this.props.is_invite_sent
                                                    ?
                                                    <button className="btn btn-outline-primary accept-btn"
                                                            type="button" disabled>
                                                        Request sent
                                                </button>
                                                :
                                                    <button type="button" className="btn btn-outline-primary"
                                                            onClick={this.sendPrivateRequestToBroadcaster}
                                                    >
                                                        {
                                                            this.state.isFetching
                                                                ?
                                                                <img src={loading_white}
                                                                     alt={"Loading"}
                                                                     width={26}/>
                                                                :
                                                                "Invite to 1 on 1 session"
                                                        }
                                                    </button>
                                        )
                                        :
                                        <button type="button" className="btn btn-outline-primary"
                                                onClick={() => {
                                                    this.acceptRequestAndCreateNewBroadcast(this.state.viewer.id)
                                                }}>
                                            {
                                                this.state.isFetching
                                                    ?
                                                    <img src={loading_white}
                                                         alt={"Loading"}
                                                         width={26}
                                                         height={26}/>
                                                    :
                                                    "Accept Invitation for 1 on 1"
                                            }
                                        </button>

                                }
                                {
                                    this.props.broadcaster_favourites.isFetching ?
                                    <button type="button" className="btn btn-link" data-dismiss="modal">
                                        <img src={loading_blue} alt={"Loading"} width={26} height={26}/>
                                    </button>
                                    :
                                    <button type="button" className="btn btn-link" data-dismiss="modal"
                                            onClick={this.props.favouriteUnFavouriteUser}>{this.props.userDetails.userData.is_favorite === "true" ? "Unfavourite user" : "Favourite user"}
                                    </button>
                                }
                                {this.props.broadcaster_block_unblock_viewer.isFetching ?
                                    <button type="button" className="btn btn-link" data-dismiss="modal">
                                        <img src={loading_blue} alt={"Loading"} width={26} height={26}/>
                                    </button>
                                    :
                                    this.props.userDetails.userData.is_blocked === "true" ?
                                        <button type="button" className="btn btn-link"
                                                data-dismiss="modal">Blocked</button>
                                        :
                                        <button type="button" className="btn btn-link" data-dismiss="modal"
                                                onClick={this.props.blockOnUnblockViewer}>Block user</button>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        broadcaster_detail_management: state.broadcaster_detail_management,
        broadcaster_favourites: state.broadcaster_favourites,
        broadcaster_block_unblock_viewer: state.broadcaster_block_unblock_viewer,
        device: state.device.payload
    };
}

export default connect(mapStateToProps, actions)(InviteForSessionModal);